export const homePageData = [
    {
        photo: '../assets/hongKongBg.png', profile: "../assets/hongkongLogo.png", name: "香港", title: "课程简介", courceIntroduction: "小學中文緊貼香港現行小學教材，如《我愛學語文》《啟思中國語文》等，重視綜合提升；小學數學課程設計基於香港小學《现代小學數學》内容，全方位提升數學能力；中學課程參考《啟思中國語文》教材，熟習多種文體的閱讀同寫作，全面提升文學素養。"
    },
    {
        photo: '../assets/singaporeBg.png', profile: "../assets/singaporeLogo.png", name: "新加坡", title: "课程简介", courceIntroduction: "小学课程以新加坡教育部颁发的《欢乐伙伴》系列教材为教学大纲的。互动式，场景化，本土化，多级别设置基础同步课，基础专项课，培优专项课以及PSLE冲刺课四大模块，针对不同年级学习情况专项提升中文学习。中学课程是以《华文伴我行》系列教材为教学大纲，内容包括写作课、词汇课以及阅读理解课等。"
    },
    {
        photo: '../assets/otherBg.png', profile: "../assets/otherLogo.png", name: "其他华裔地区", title: "课程简介", courceIntroduction: "面向4—16岁海外华裔少儿先进的在线教育平台沉浸式1对1教学/ 优质小班故事会 / 1对多中文趣味课平台影响力遍布全球多个国家和地区"
    }]

